import type { PaymentMethod } from '@shared/contracts/enums'

export function paymentMethodLabel(method: string): string {
  const labels: Record<PaymentMethod, string> = {
    CREDIT_CARD: 'Cartão de crédito',
    PIX: 'Pix',
    BOLETO: 'Boleto',
    PAYPAL: 'PayPal',
    APPLE_PAY: 'Apple Pay',
    GOOGLE_PAY: 'Google Pay',
    AMAZON_PAY: 'Amazon Pay',
  }
  return (
    labels[method as PaymentMethod] ??
    method
      .split('_')
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ')
  )
}
